export * from './sidenav.component';
export * from './sidenav.module';



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/sidenav/index.ts